import type { APPLICANT_ATTRIBUTION } from 'cpool-constants';

import { getBaseCreditDefaultValues } from './baseCredit';

export const getDispositionskreditDefaultValues = (attribution: APPLICANT_ATTRIBUTION) => ({
    ...getBaseCreditDefaultValues(attribution),
    abloesen: false,
    beanspruchterBetrag: null,
    bic: null,
    iban: null,
    kreditinstitut: null,
    verfuegungsrahmen: null,
    zinssatz: null,
});
